export default __webpack_public_path__ + "static/media/DIY02.e71fb5fb.JPG";